// @flow
import React, {useContext} from "react";
import LIUtils from "../GUI_COMMON/SUPPORT/LIUtils";
import {StoreContext} from "../GUI_COMMON/SUPPORT/store";
import GuiUtils from "../GUI_COMMON/SUPPORT/GuiUtils";
import type {BTOBox} from "./BTOAddUpdatePage";
import ArchiverGuiUtils from "../SUPPORT/ArchiverGuiUtils";

interface BoxCardProps {
    info: BTOBox,
    onClick?: any,
}

const BoxCard: React.FC<BoxCardProps> = ({info, onClick}) => {
    
    const [globalState] = useContext(StoreContext);
    
    function handleOnClick() {
        if(onClick) {
            onClick();
        }
    }
    
    function getLastModifiedDate() {
        if(info?.dateModified===null) {
            return "never";
        }
        
        return LIUtils.shortDateFromJsonUtcDateStr(info.dateModified);
    }
    
    function dumpHoldsMagType(magType:number) {
        return GuiUtils.GetMagTypeNameGivenId(magType, globalState.magTypes.items) ?? "?";
    }
    
    function dumpBoxImage() {
        return (
            <span className={"badge li-font-large font-weight-bold p-1 px-2 rounded mr-2 li-border-muted"}>
               <i className="fa fa-box-open li-fg-box"></i>
            </span>   
        );
    }
    
    function dumpStorageLocation(deptId:number) {
        const locStr = ArchiverGuiUtils.GetLocationBasedOnDeptId(deptId, globalState.locations);
        if (!locStr) {
            return null;
        }
        return (<>
            <strong>Stored At</strong><i>{locStr}</i>
            </>);
    }
    
    // function dumpForeignRefName() {
    //     let foreignSpan = ArchiverGuiUtils.GetForeignRefBadgeForBox(info);
    //     if(!foreignSpan) { // leave space
    //         return <span className="li-font-small">&nbsp;</span>;
    //     }
    //     return <span style={{width:"fit-content",marginLeft:"auto"}}>{foreignSpan}</span>;
    // }
    
    if(info===null) { // spacer / empty mag card holder
        return <div className="card li-mag-card clear"/>;
    }

    return(
        <div className="card li-box-card" onClick={handleOnClick}>
            <div className="card-body">
                <div className="row justify-content-between py-1 m-0 h-100">
                    <div>
                        <div className="mb-1">
                            {dumpBoxImage()}
                            <span className="card-title li-font-large font-weight-bold">{info.barcode}</span>
                        </div>
                        <div className="li-font-tiny mt-2"><strong>Holds:</strong> {dumpHoldsMagType(info.holdsMagType)}</div>
                    </div>
                   
                    <div className="d-flex flex-column text-right li-font-small li-bg-primary-accent rounded">
                        {/*dumpForeignRefName()*/}
                        {dumpStorageLocation(info.storageLocationId)}
                       
                        <div className="li-font-tiny" style={{minWidth:"110px"}}><strong>Updated:</strong> {getLastModifiedDate()}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default BoxCard;